import React, { useEffect, useState } from "react";
import {
  DialogContent,
  Button,
  Stack,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Chip,
  TextField,
  Checkbox,
  Grid,
  Divider,
} from "@mui/material";
import { handleSessionOut, Loader, SectionBox } from "../HelperFunctions/HelperFunctions";
import { useFormikContext } from "formik";
import { useLoaderData } from "react-router-dom";
import { getScheduleCategories } from "../API/nimbleAPI";
import { enqueueSnackbar } from "notistack";
import { checkDuplicateReportbook } from "../API/backend";


const ReportCategories = ({ slide, setSlide, onClose }) => {
  const { privileges = {}, clientID, clientName, token } = useLoaderData();

  const { values, setFieldValue, handleChange } = useFormikContext();
  const [loading, setLoading] = useState(false);
  const [propertyFinancialAccountant, setPropertyFinancialAccountant] =
    useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      setLoading(true);
      let data = await getScheduleCategories();
      setPropertyFinancialAccountant(data["schedules"].map((i) => i.report));
      setFieldValue("reportsViewerData", data);
    } catch (error) {
      enqueueSnackbar("Error while getting data", { variant: "error" })
    } finally {
      setLoading(false);
    }
  };

  const handleNextSlide = async () => {
    try {
      if (!values.reportBookName) {
        enqueueSnackbar("Please enter the Report Book Name.", { variant: "info" });
        return;
      }
      if (Object.keys(values.checkedItems).length === 0) {
        enqueueSnackbar("Please select at least one item.", { variant: "info" });
        return;
      }
      const scheduleId = values?.schedule_id || ""
      const validateReportName = await checkDuplicateReportbook(values.reportBookName, clientID, scheduleId)
      if (validateReportName.is_duplicate) {
        enqueueSnackbar("This Report Book Name already exists.", { variant: "warning" });
        return;
      }
      setSlide(slide + 1);

    } catch (error) {
      if (error.status === 401) {
        await handleSessionOut()
      }
    }
  };


  const CustomerVendorAndEmployeeReports = {
    vendor: [
      "A/P Aging Summary",
      "A/P Aging Details",
      "Combined A/P Aging Summary",
      "Combined A/P Aging Details",
      "A/P Aging Summary By Transaction Date",
      "A/P Aging Details By Transaction Date",
      "Vendor Wise Aging Details",
      "Vendor Summary",
      "Vendor Transaction List",
      "1099 Payments",
      "Vendor Contact List",
      "Stock Report",
      "1099 Summary",
      "1099 Detail",
      "Bill Summary",
      "Bill Payment Details",
      "Sales/Vendor Tax Report",
      "Vendor Tax Details Report",
      "Open Invoice List",
    ],

    Customer: [
      "A/R Aging Summary",
      "A/R Aging Details",
      "A/R Aging Summary By Transaction Date",
      "A/R Aging Details By Transaction Date",
      "Customer Summary",
      "Customer Transaction List",
      "Customer Contact List",
      "Invoice Summary",
    ],
    InvoiceSummary: [
      "Employee Contact List",
      "Employee Transaction List",
      "Payroll Details by Department Report",
      "Payroll Summary",
      "Payroll Summary by Date",
      "Payroll Item Details",
      "Payroll Statement",
    ],
  };
  const CustomerStrAndList = {
    STR: ["STR", "GS Comments", "GS Key Driver"],

    Customer: [
      "Budget Review",
      "Forecast Review",
      "Actual Vs. Budget Vs. Forecast",
      "Combined Budget",
      "Combined Forecast",
    ],

    lists: [
      "Chart of Accounts",
      "Item List",
      "Recurring Transaction",
      "Void Transaction",
      "Others Transaction List",
      "Others Contact List",
    ],
  };

  const reportCategories = [
    {
      value: "property_financials_and_accountant",
      label: "Property Financials & Accountant",
    },
    // { value: "customer_and_vendor_and_employee", label: "Customer, Vendor and Employee" },
    // { value: "str_and_gss_and_budgeting", label: "STR, GSS and Budgeting" }
  ];
  const reportFrequencies = [
    { value: "weekly", label: "Weekly" },
    { value: "semi_monthly", label: "Semi - Monthly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "half_yearly", label: "Half Yearly" },
    { value: "yearly", label: "Yearly" },
  ];
  const reportFromOptions = [
    { value: "monday_to_sunday", label: "Monday - Sunday" },
    { value: "tuesday_monday", label: "Tuesday - Monday" },
    { value: "wednesday_tuesday", label: "Wednesday - Tuesday" },
    { value: "thursday_wednesday", label: "Thursday - Wednesday" },
    { value: "friday_thursday", label: "Friday - Thursday" },
    { value: "saturday_friday", label: "Saturday - Friday" },
    { value: "sunday_saturday", label: "Sunday - Saturday" },
  ];

  const handleCheckboxToggle = (label) => {
    const updated = { ...values.checkedItems };
    if (updated[label]) {
      delete updated[label];
    } else {
      updated[label] = true;
    }
    setFieldValue("checkedItems", updated);
  };

  return (
    <>
      <DialogContent
        sx={{
          p: 0,
          bgcolor: "#f4f4f4",
          height: "calc(100vh - 45px)",
        }}
      >
        <Box p={1} bgcolor={"white"} height={"60px"} minWidth={"870px"}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Stack gap={2} direction={"row"}>
              <TextField
                sx={{ minWidth: 200 }}
                label="Report Book Name"
                // size="small"
                variant="standard"
                name="reportBookName"
                value={values.reportBookName}
                onChange={handleChange}
              />

              <FormControl sx={{ minWidth: 250, maxWidth: 280, m: 1 }}>
                <InputLabel id="bulk-action-label">
                  Category of Reports
                </InputLabel>
                <Select
                  size="small"
                  label="Category of Reports"
                  name="categoryOfReport"
                  value={values.categoryOfReport}
                  onChange={handleChange}
                >
                  {reportCategories.map((category) => (
                    <MenuItem key={category.value} value={category.value}>
                      {category.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 150, maxWidth: 280, m: 1 }}>
                <InputLabel id="bulk-action-label">Report Book Type</InputLabel>
                <Select
                  size="small"
                  label="Report Book Type"
                  name="reportBookType"
                  value={values.reportBookType}
                  onChange={handleChange}
                >
                  {/* <MenuItem value="periodic_reports">Periodic Reports</MenuItem> */}
                  <MenuItem value="custom_reports">Custom Reports</MenuItem>
                </Select>
              </FormControl>
              {values.reportBookType === "periodic_reports" && (
                <FormControl sx={{ minWidth: 150, maxWidth: 280, m: 1 }}>
                  <InputLabel id="bulk-action-label">Report Frequency</InputLabel>
                  <Select
                    size="small"
                    label="Report Frequency"
                    name="reportFrequency"
                    value={values.reportFrequency}
                    onChange={handleChange}
                  >
                    {reportFrequencies.map((freq) => (
                      <MenuItem key={freq.value} value={freq.value}>
                        {freq.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {values.reportFrequency === "weekly" &&
                values.reportBookType === "periodic_reports" && (
                  <FormControl sx={{ minWidth: 150, maxWidth: 280, m: 1 }}>
                    <InputLabel id="bulk-action-label">Report From</InputLabel>
                    <Select
                      size="small"
                      label="Report From"
                      name="reportFrom"
                      value={values.reportFrom}
                      onChange={handleChange}
                    >
                      {reportFromOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
            </Stack>
            <Box>
              <Stack direction={"row"} gap={1}>
                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  disableRipple
                  sx={{
                    px: 4,
                    textTransform: "none",
                    backgroundColor: "#b5dcf2",
                    color: "#000",
                    fontWeight: 400,
                  }}
                  onClick={onClose}
                >
                  Close
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  disableRipple
                  sx={{
                    // px: 3,
                    textTransform: "none",
                    backgroundColor: "#b5dcf2",
                    color: "#000",
                    fontWeight: 400,
                    minWidth: "100px",
                  }}
                  onClick={handleNextSlide}
                >
                  Save & Next
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Box>

        {values.categoryOfReport === "property_financials_and_accountant" && (
          <Box mt={5} p={1} bgcolor={"#f4f4f4"}>
            <SectionBox
              title={"Property Financials  & Accountant"}
              height={"520px"}
              bgcolor={"#f4f4f4"}
              fontWeight={700}
              minWidth={"840px"}
            >
              <Grid container spacing={0.5}>
                {propertyFinancialAccountant.map((label, index) => (
                  <Grid item xs={3} key={index}>
                    <Chip
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "350px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <Checkbox
                            disableRipple
                            checked={values.checkedItems[label] || false}
                            onChange={() => handleCheckboxToggle(label)}
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 22,
                                color: values.checkedItems[label]
                                  ? "green"
                                  : "inherit",
                              },
                            }}
                          />
                          {label}
                        </Box>
                      }
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: 400,
                        mt: 1,
                        width: "350px",
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </SectionBox>
          </Box>
        )}

        {values.categoryOfReport === "customer_and_vendor_and_employee" && (
          <Box mt={5} p={1} bgcolor={"#f4f4f4"}>
            <SectionBox
              title={"Customer, Vendor and Employee Reports"}
              height={"490px"}
              bgcolor={"#f4f4f4"}
              fontWeight={700}
              minWidth={"840px"}
            >
              <Grid container spacing={2}>
                {Object.entries(CustomerVendorAndEmployeeReports).map(
                  ([category, reports], index, array) => (
                    <Grid item xs={12} key={category}>
                      <Chip
                        disableRipple
                        label={category.replace("_", " ")}
                        sx={{
                          backgroundColor: "#d7d7d7",
                          mb: 1,
                          borderRadius: "6px",
                          fontSize: "14px",
                          fontWeight: 600,
                          width: "100%",
                        }}
                      ></Chip>

                      <Grid container spacing={1}>
                        {reports.map((label, index) => (
                          <Grid item xs={3} key={index}>
                            <Chip
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "350px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Checkbox
                                    disableRipple
                                    checked={values.checkedItems[label] || false}
                                    onChange={() => handleCheckboxToggle(label)}
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: 22,
                                        color: values.checkedItems[label]
                                          ? "green"
                                          : "inherit",
                                      },
                                    }}
                                  />
                                  {label}
                                </Box>
                              }
                              sx={{
                                backgroundColor: "white",
                                borderRadius: "6px",
                                fontSize: "13px",
                                fontWeight: 400,
                                width: "350px", // Ensures consistency
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      {index !== array.length - 1 && (
                        <Divider sx={{ color: "red", mt: 0.8 }} />
                      )}
                    </Grid>
                  )
                )}
              </Grid>
            </SectionBox>
          </Box>
        )}
        {values.categoryOfReport === "str_and_gss_and_budgeting" && (
          <Box mt={5} p={1} bgcolor={"#f4f4f4"}>
            <SectionBox
              title={"Customer STR and Lists"}
              height={"490px"}
              bgcolor={"#f4f4f4"}
              fontWeight={700}
              minWidth={"840px"}
            >
              <Grid container spacing={2}>
                {Object.entries(CustomerStrAndList).map(
                  ([category, reports], index, array) => (
                    <Grid item xs={12} key={category}>
                      {/* Category Chip */}
                      <Chip
                        disableRipple
                        label={category}
                        sx={{
                          backgroundColor: "#d7d7d7",
                          mb: 1,
                          borderRadius: "6px",
                          fontSize: "14px",
                          fontWeight: 600,
                          width: "100%",
                        }}
                      />

                      <Grid container spacing={1}>
                        {reports.map((label, idx) => (
                          <Grid item xs={3} key={idx}>
                            <Chip
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "350px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Checkbox
                                    disableRipple
                                    checked={values.checkedItems[label] || false}
                                    onChange={() => handleCheckboxToggle(label)}
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: 22,
                                        color: values.checkedItems[label]
                                          ? "green"
                                          : "inherit",
                                      },
                                    }}
                                  />
                                  {label}
                                </Box>
                              }
                              sx={{
                                backgroundColor: "white",
                                borderRadius: "6px",
                                fontSize: "13px",
                                fontWeight: 400,
                                width: "350px",
                                mt: 1,
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>

                      {index !== array.length - 1 && (
                        <Divider sx={{ color: "red", mt: 0.8 }} />
                      )}
                    </Grid>
                  )
                )}
              </Grid>
            </SectionBox>
          </Box>
        )}
      </DialogContent>
      {loading && <Loader loading={loading} />}
    </>
  );
};

export default ReportCategories;
